import React, { useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay";
import axios from "../../../axios/axios";
import { message } from "antd";
import DataTable from "react-data-table-component";
import moment from "moment";
import { Button } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { DATE_TIME_FORMAT } from "../../../constants/constants";
import { adminConfig } from "../../../utils/adminConfig";

const columns = [
  {
    name: "From To",
    selector: (row) => (
      <>
        <p>Name : {row?.fromUserData?.name}</p>
        <p>Email : {row?.fromUserData?.email}</p>
        <p>Username : {row?.fromUserData?.userName}</p>
      </>
    ),
    width: "250px",
  },
  {
    name: "Sent To",
    selector: (row) => {
      return (
        <>
          <p>{row.email}</p>
          <p>{row?.phoneNumber}</p>
        </>
      );
    },
    width: "200px",
  },
  {
    name: "Sent At",
    selector: (row) => moment(row.createdAt).format(DATE_TIME_FORMAT),
  },
  {
    name: "Certificate ID",
    selector: ({ certificate }) => certificate.certificateId,
    width: "150px",
  },
  {
    name: "Certificate Title",
    selector: ({ certificate }) => certificate.certificateTitle,
    width: "250px",
  },
  {
    name: "Certificate Code",
    selector: (row) => row.certificateEmbeddedCode,
    width: "200px",
  },
  {
    name: "Certificate Price",
    selector: (row) => <>${row.certificate.certificatePrice}</>,
  },
];

export default function SendCertificate() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [redeemCertificate, setRedeemCertificate] = useState([]);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    getAllSendCertificate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, query]);

  const getAllSendCertificate = () => {
    setLoading(true);

    axios
      .get(
        `/get-all-send-certificates?limit=${limit}&page=${page}&query=${query}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          setRedeemCertificate(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        message.error("Something went wrong");
      });
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(`/get-all-send-certificates-csv?query=${search}`,adminConfig())
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            FromName: member?.fromUserData?.name,
            FromEmail: member?.fromUserData?.email,
            SentEmail: member.email,
            SentPhone: member.phone,
            SentAt: moment(member.createdAt).format("MM-DD-YYYY, h:mm a"),
            CertificateID: member.certificate.certificateId,
            CertificateTitle: member.certificate.certificateTitle,
            CertificateCode: member.certificateEmbeddedCode,
            CertificatePrice: "$" + member.certificate.certificatePrice,
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "From Name", key: "FromName" },
    { label: "From Email", key: "FromEmail" },
    { label: "Sent Email", key: "SentEmail" },
    // { label: "Sent Phone", key: "SentPhone" },
    { label: "SentAt", key: "SentAt" },
    { label: "Certificate ID", key: "CertificateID" },
    { label: "Certificate Title", key: "CertificateTitle" },
    { label: "Certificate Code", key: "CertificateCode" },
    { label: "Certificate Price", key: "CertificatePrice" },
  ];

    useEffect(() => {
      if(query){
        setSearch(query);
      }
    },[query])

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>All Send Certificates</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>
                <div className="filter_section">
                  <div className="input-group filter_fields">
                    <div className="search_field">
                      <input
                        placeholder="Search here ..."
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                        value={query}
                      />
                    </div>

                    <Button
                      className="search_button"
                      variant="primary"
                      onClick={() => {
                        setSearch(query);
                        setPage(1);
                      }}
                    >
                      Search
                    </Button>

                    <Button
                      className="search_button"
                      variant="secondary"
                      disabled={!search}
                      onClick={() => {
                        setSearch("");
                        setQuery("");
                        setPage(1);
                      }}
                    >
                      Clear Filter
                    </Button>
                  </div>
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`sent_certificates_${Date.now()}.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />

                    <button
                      type="button"
                      className="btn btn-primary search_button"
                      onClick={() => {
                        window.open("/available-certificate");
                      }}
                    >
                      Available Certificates
                    </button>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={redeemCertificate}
                  highlightOnHover
                  pagination
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 40, 100]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
}
